import { useEffect, useState } from 'react';

import Link from 'next/link';
import { useTranslation } from 'next-i18next/pages';

import { Modal } from 'antd';

import { TranslationNamespace } from '@/i18n';

import type { CalculationResult, ChartScenario } from '../../lib';

import { CostChart } from './CostChart';

import styles from '@/components/TariffCalculatorNew/TariffCalculator.module.scss';

interface ChartModalProps {
	open: boolean;
	result: CalculationResult;
	onClose: () => void;
}

export function ChartModal({ open, result, onClose }: ChartModalProps) {
	const { t } = useTranslation(TranslationNamespace.Calculator);
	const [scenario, setScenario] = useState<ChartScenario>('pos');

	useEffect(() => {
		if (open) setScenario('pos');
	}, [open]);

	return (
		<Modal
			open={open}
			onCancel={onClose}
			footer={null}
			width={1040}
			destroyOnHidden
			className={styles.chartAntdModal}
			style={{ top: 100, paddingBottom: 24 }}
			styles={{ body: { padding: 0 } }}
			title={null}
			closable
		>
			<div className={styles.chartDialogInner}>
				<h2 id="chartTitle">{t('chart.title')}</h2>
				<p>{t('chart.description')}</p>

				<div className={styles.scenarioSwitch} aria-label={t('chart.scenario-label')}>
					<button
						type="button"
						aria-pressed={scenario === 'cons'}
						onClick={() => setScenario('cons')}
					>
						{t('chart.conservative')}
					</button>
					<button
						type="button"
						aria-pressed={scenario === 'pos'}
						onClick={() => setScenario('pos')}
					>
						{t('chart.positive')}
					</button>
				</div>

				<CostChart groups={result.groups} scenario={scenario} />

				<div className={styles.chartLegend} aria-hidden="true">
					<span>
						<i className={styles.legendSwatch} style={{ background: '#126783' }} />
						<b>{t('chart.current')}</b>
					</span>
					<span>
						<i className={styles.legendSwatch} style={{ background: '#f2762e' }} />
						<b>{t('chart.potential')}</b>
					</span>
				</div>

				<div className={styles.modalCta}>
					<div>
						<strong>{t('chart.try-free')}</strong>
						<span>{t('chart.try-free-note')}</span>
					</div>
					<Link className={styles.startFree} href="/" target="_blank" rel="noopener noreferrer">
						{t('chart.start-free')}
					</Link>
				</div>
			</div>
		</Modal>
	);
}
